import React, { useId } from 'react';
import PropTypes from 'prop-types';
import Label from '../../atoms/Label';

const FormField = ({
  label,
  htmlFor,
  required = false,
  helperText,
  errorMessage,
  children,
  className = ''
}) => {
  const generatedId = useId();
  const fieldId = htmlFor || generatedId;
  const messageId = `${fieldId}-field-message`;

  const control = React.isValidElement(children)
    ? React.cloneElement(children, {
      id: children.props.id || fieldId,
      error: children.props.error ?? Boolean(errorMessage),
      helperText: children.props.helperText ?? undefined,
      errorMessage: children.props.errorMessage ?? errorMessage,
      'aria-describedby': messageId
    })
    : children;

  return (
    <div className={className}>
      {label && (
        <Label htmlFor={fieldId} required={required} className="mb-1.5 block">
          {label}
        </Label>
      )}
      {control}
      {!React.isValidElement(children) && helperText && !errorMessage && (
        <p id={messageId} className="mt-1.5 text-sm text-gray-500">{helperText}</p>
      )}
      {!React.isValidElement(children) && errorMessage && (
        <p id={messageId} className="mt-1.5 text-sm text-red-600" role="alert">{errorMessage}</p>
      )}
    </div>
  );
};

FormField.displayName = 'FormField';

FormField.propTypes = {
  label: PropTypes.node,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default FormField;
